import { useShouldUseTeamsFocusNavigation } from '@ms/yammer-hooks/dist/teams';
import { ReturnFocusType, returnFocusHandler } from '@ms/yammer-web-support/dist/metaOsHub';
import React, { FC, KeyboardEvent, useCallback } from 'react';

const EscapeKeyNavigationHandler: FC = ({ children }) => {
  const shouldUseTeamsFocusNavigation = useShouldUseTeamsFocusNavigation();

  const keyDownHandler = useCallback((event: KeyboardEvent) => {
    if (event.code !== 'Escape') {
      return;
    }

    if (event.shiftKey || event.metaKey || event.ctrlKey) {
      return;
    }

    returnFocusHandler(ReturnFocusType.GoToActivityFeed);
  }, []);

  if (shouldUseTeamsFocusNavigation) {
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    return <div onKeyDown={keyDownHandler}>{children}</div>;
  }

  return <>{children}</>;
};

export default EscapeKeyNavigationHandler;
